var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-body"},[_c('div',{staticClass:"admin-nav navbar-collapse",attrs:{"id":"nav"}},[_c('div',{staticClass:"admin-nav-fixbox"},[_c('PrimaryNavigation'),_c('SecondaryNavigation')],1)]),_c('PageWithNavbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }